import axios from 'axios';
import { storeHomeClient, ImResponse, resolve } from '.';
import { getLeYanBotHost } from './leyanBotHost';

export interface ListParams {
  region: General.UpperCaseRegion;
  externalType?: General.PlatformUpperCase;
}

export function list(params?: ListParams) {
  return resolve(
    storeHomeClient.get<ImResponse<Store.StoreGroup[]>>('/store_groups', {
      params,
    }),
  );
}

export function fetch(id: Store.StoreGroup['id']) {
  return resolve(storeHomeClient.get<ImResponse<Store.StoreGroup>>(`/store_groups/${id}`));
}

export function create(
  body: Omit<Store.StoreGroup, 'id' | 'orgId' | 'watchLimitEnable'> & {
    scenePackValue: Store.ScenarioPackValue;
  },
) {
  return resolve(storeHomeClient.post<ImResponse<Store.StoreGroup>>('/store_groups', body));
}

export function update(
  body: Omit<Store.StoreGroup, 'orgId' | 'watchLimitEnable'> & {
    scenePackValue: Store.ScenarioPackValue;
  },
) {
  const { id } = body;

  return resolve(storeHomeClient.put<ImResponse<never>>(`/store_groups/${id}/scene`, body));
}

export function updateStatus(body: Pick<Store.StoreGroup, 'id' | 'status'>) {
  return resolve(storeHomeClient.put<ImResponse<never>>('/store_groups', body));
}

export function del(id: Store.StoreGroup['id']) {
  return resolve(storeHomeClient.delete<ImResponse<never>>(`/store_groups/${id}`));
}

export function fetchScenarioPackList(params: {
  id?: Store.StoreGroup['id'];
  domains: string;
  region: General.UpperCaseRegion;
  externalType: General.PlatformUpperCase | 'MIXED';
}) {
  return resolve(
    storeHomeClient.get<ImResponse<Store.ScenarioPackValue>>(`/store_groups/scene_pack`, {
      params,
    }),
  );
}

export function fetchToken(id: string | number) {
  return resolve(storeHomeClient.get<ImResponse<string>>(`/store_groups/${id}/token`));
}

export interface ScenarioParams {
  storeGroupId: string | number;
  scenarioId: string | number;
  lang: General.SystemLanguage;
}

export function scenario(params: ScenarioParams) {
  const { storeGroupId, scenarioId, lang } = params;

  return fetchToken(storeGroupId).then((token) => {
    const langMap: Partial<Record<General.SystemLanguage, string>> = {
      'en-US': 'en',
      'zh-CN': 'cn',
    };

    return axios.get<{ label: string }>(
      `${getLeYanBotHost()}/overseaim-store-home/api_gateway/policy/scenarios/${scenarioId}`,
      {
        headers: {
          authorization: `Bearer ${token}`,
          lang: langMap[lang] || 'en',
        },
      },
    );
  });
}
